import * as yup from "yup";

const LineItemDrayageSchema = yup.object().shape({
  type_container: yup.string().required(),
  overweight: yup.boolean(), // asegúrate de incluir este campo si lo estás usando como condición

  weight_units: yup
    .string()
    .when("overweight", {
      is: true,
      then: (schema) => schema.required("Weight units is required when overweight is true"),
      otherwise: (schema) => schema.notRequired(),
    }),

  weight: yup
    .string()
    .when("overweight", {
      is: true,
      then: (schema) => schema
        .required("Weight is required when overweight is true")
        .test(
          "is-positive",
          "The value must be greater than 0",
          (value) => parseFloat(value) > 0
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

  description: yup.string().required(),
});

export default LineItemDrayageSchema;
